"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _getOwnPropertyNames = require("babel-runtime/core-js/object/get-own-property-names");

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = require("babel-runtime/core-js/object/get-own-property-descriptor");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

var _mobx = require("mobx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SimgateInputStore = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = function () {
  function SimgateInputStore() {
    var _this = this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SimgateInputStore);
    this.inputSuffixRegex = /:(G|(\+|-)[0-9]{1,2})$/;

    _initDefineProp(this, "id", _descriptor, this);

    _initDefineProp(this, "pathId", _descriptor2, this);

    _initDefineProp(this, "dataWasChanged", _descriptor3, this);

    _initDefineProp(this, "dataWillLoad", _descriptor4, this);

    _initDefineProp(this, "dataWasLoaded", _descriptor5, this);

    _initDefineProp(this, "dataWillSave", _descriptor6, this);

    _initDefineProp(this, "dataWasSaved", _descriptor7, this);

    _initDefineProp(this, "inputWasUpdated", _descriptor8, this);

    _initDefineProp(this, "stateWasSet", _descriptor9, this);

    _initDefineProp(this, "inputs", _descriptor10, this);

    _initDefineProp(this, "_cache", _descriptor11, this);

    this.getInput = function (contentModel, varName) {
      if (!contentModel) throw new Error("must provide content model");
      if (!varName) throw new Error("must provide varName");

      var inputStore = this;

      var input = contentModel[varName];
      if (!input) throw new Error("the contentmodel does not contain this input: " + varName);

      var inputVariableName = input.variable;
      if (!inputVariableName) throw new Error("the input does not contain a variable name: " + input);

      return inputStore.inputs[inputVariableName];
    }.bind(this);

    if (!opts.simgate && !this.constructor.simgate) throw new Error("provide simgate as static property or argument at instantiation");
    this.simgate = opts.simgate || this.constructor.simgate;

    if (opts.pathId) this.pathId = opts.pathId;
    this.id = opts.id || this.constructor.id || this.constructor.name;

    setTimeout(function () {
      return _this.updateCache();
    }, 10);
  }

  (0, _createClass3.default)(SimgateInputStore, [{
    key: "isLoadableVariable",
    value: function isLoadableVariable(name) {
      var prop = void 0;
      return !(0, _mobx.isComputed)(this.inputs, name) // isnt a computed 
      || this.inputs.$mobx.values[name] && this.inputs.$mobx.values[name].hasOwnProperty('setter') // or has a setter
      || (prop = (0, _getOwnPropertyDescriptor2.default)(this.inputs.$mobx.target, name)) && prop.set && prop.set.toString().substring(9, 13) === "set"; // special setter...
    }
  }, {
    key: "updateCache",
    value: function updateCache() {
      this._cache = this._serialized;
    }
  }, {
    key: "revert",
    value: function revert() {
      var reverted = {};
      try {
        reverted = JSON.parse(this._cache);
      } catch (e) {}
      (0, _assign2.default)(this.inputs, reverted);
    }
  }, {
    key: "updateInput",
    value: function updateInput(name, value, offsets) {
      var _this2 = this;

      if (!name || name.indexOf(":") === -1) return console.warn("please supply full variable name (ex: G:IndMonth:G)");
      if (!this.inputs.hasOwnProperty(name)) return console.warn("this input does not exist");
      this.inputs[name] = value;
      if (Array.isArray(offsets)) offsets.forEach(function (offset) {
        return _this2.inputs[name.replace(_this2.inputSuffixReg, ":" + offset)] = value;
      });
      this.inputWasUpdated = { time: +new Date(), name: name, offsets: offsets || [] };
    }
  }, {
    key: "setState",
    value: function setState(values, varNames) {
      var _this3 = this;

      if (!varNames) return console.log("no varnames when setting state");
      varNames.forEach(function (name, index) {
        var prop = void 0;
        if (!_this3.inputs.hasOwnProperty(name)) return console.warn("missing input property: " + name);
        if (values[index] != null //not null (dont want null to overwrite default val in the class)
        && (!(_this3.inputs.$mobx.values[name] && _this3.inputs.$mobx.values[name].hasOwnProperty('derivation')) || _this3.inputs.$mobx.values[name] && _this3.inputs.$mobx.values[name].hasOwnProperty('setter') || (prop = (0, _getOwnPropertyDescriptor2.default)(_this3.inputs.$mobx.target, name)) && prop.set && prop.set.toString().substring(9, 13) === "set") //isnt computed, or has a setter
        ) {
            _this3.inputs[name] = values[index];
          }
      });
      this.stateWasSet = { time: +new Date(), vars: varNames };
    }
  }, {
    key: "saveData",
    value: function saveData(cb, errCb) {
      var _this4 = this,
          _arguments = arguments;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!this.simgate) throw new Error("input store missing simgate!");

      var pathId = this.pathId || opts.pathId || this.$parent && this.$parent.pathId;

      if (!pathId) throw new Error("no pathId provided");

      if (!this.isLoaded) return setTimeout(function () {
        console.warn("possible race condition, trying to save again");
        _this4.saveData.apply(_this4, _arguments);
      }, 500);

      this.dataWillSave = +new Date();

      var vars = [];
      var values = [];

      this.savableVariableNames.forEach(function (key) {
        vars.push(key);
        values.push(_this4.inputs[key]);
      });

      if (!vars.length) {
        successCb();
        return console.warn("no savable variables!");
      }

      var successCb = function successCb(res) {
        _this4.updateCache();
        _this4.dataWasSaved = +new Date();
        cb && cb.apply(undefined, _arguments);
      };

      var adaptedVals = void 0;

      var taskArgs = [this.simgate.updateData, {
        path: pathId,
        set: vars.reduce(function (acc, name, index) {
          acc[name] = values[index];
          return acc;
        }, {})
      }, (0, _assign2.default)({
        onSuccess: successCb,
        onFailure: errCb
      }, opts)];

      if (opts.blockingSave !== false && this.simgate.runTask) {
        var _simgate;

        (_simgate = this.simgate).runTask.apply(_simgate, taskArgs);
      } else if (opts.blockingSave !== false && this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.updateData(taskArgs[1]).then(successCb).catch(errCb);
      }
    }
  }, {
    key: "loadData",
    value: function loadData(cb, errCb) {
      var _this5 = this;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      /* in most cases this gets overriden by simgate-datamodel */
      if (!this.simgate) throw new Error("input store missing simgate!");

      if (this.isLoading) return console.log("already loading...");

      var pathId = this.pathId || opts.pathId || this.$parent && this.$parent.pathId;
      if (!pathId) return console.warn("no pathId");

      if (!this.loadableVariableNames.length) {
        this.dataWasLoaded = +new Date();
        cb && cb();
        return console.warn("no loadable variables!");
      }

      this.dataWillLoad = +new Date();

      //only clear data if data has already been saved (avoid wiping defaults)
      if (this.dataWasSaved) this.clearData();

      var successCb = function successCb(res) {
        _this5.setState(res.data[0].values, _this5.loadableVariableNames);
        _this5.updateCache();
        _this5.dataWasLoaded = +new Date();
        cb && cb(res);
      };

      var errorCb = function errorCb(err) {
        _this5.dataWasLoaded = +new Date();
        errCb && errCb(err);
      };

      var taskArgs = [this.simgate.selectData, {
        path: pathId,
        select: this.loadableVariableNames
      }, (0, _assign2.default)({
        onSuccess: successCb,
        onFailure: errorCb
      }, opts)];

      if (this.simgate.runTask) {
        var _simgate2;

        (_simgate2 = this.simgate).runTask.apply(_simgate2, taskArgs);
      } else if (this.simgate.AsyncTask) {
        var asyncTask = new this.simgate.AsyncTask();
        asyncTask.runTask.apply(asyncTask, taskArgs);
      } else {
        this.simgate.selectData(taskArgs[1]).then(successCb).catch(errorCb);
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var _this6 = this;

      this.loadableVariableNames.forEach(function (key) {
        try {
          _this6.inputs[key] = null;
        } catch (e) {
          console.warn("skipping nullification of " + key);
        }
      });
    }
  }, {
    key: "extendData",
    value: function extendData(src, val) {
      if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) !== "object" || (typeof src === "undefined" ? "undefined" : (0, _typeof3.default)(src)) !== "object") throw new Error("src and val should be an object");
      (0, _mobx.extendObservable)(src, val);
      this.dataWasChanged = +new Date();
    }
  }, {
    key: "setInput",
    value: function setInput(contentModel, varName, val) {
      if (!contentModel) throw new Error("must provide content model");
      if (!varName) throw new Error("must provide varName");
      if (val === undefined) throw new Error("must provide val");

      var inputStore = this;

      var input = contentModel[varName];
      if (!input) throw new Error("the contentmodel does not contain this input: " + varName);

      var inputVariableName = input.variable;
      if (!inputVariableName) throw new Error("the input does not contain a variable name: " + input);

      inputStore.updateInput(inputVariableName, val);
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return !this.isLoading && this.dataWasLoaded;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.dataWasLoaded < this.dataWillLoad;
    }
  }, {
    key: "isSaved",
    get: function get() {
      return !this.isSaving && this.dataWasSaved;
    }
  }, {
    key: "isSaving",
    get: function get() {
      return this.dataWasSaved < this.dataWillSaved;
    }
  }, {
    key: "variableNames",
    get: function get() {
      var _this7 = this;

      this.dataWasChanged; //listen to this!
      var vars = (0, _getOwnPropertyNames2.default)(this.inputs);

      return vars.filter(function (v) {
        return v.indexOf("$") === -1 && v.charAt(1) === ":" && ( //isnt $mobx or other hidden prop, has a ":" at 2nd char ("G:", "O:", "I:", etc)
        v.indexOf(":+") === -1 && v.indexOf(":-") === -1 || //isnt relative time
        !_this7.domainStore //OR is relative, but no domainstore to check roundNo
        || _this7.domainStore.currentRoundNo //or is relative, there is domainstore, and roundNo is set
        );
      });
    }
  }, {
    key: "loadableVariableNames",
    get: function get() {
      var _this8 = this;

      return this.variableNames.filter(function (name) {
        return _this8.isLoadableVariable(name);
      });
    }
  }, {
    key: "savableVariableNames",
    get: function get() {
      return this.variableNames.filter(function (name) {
        return name.indexOf("G:") === 0 || name.indexOf("I:") === 0;
      });
    }
  }, {
    key: "_serialized",
    get: function get() {
      var _this9 = this;

      return (0, _stringify2.default)(
      // should this be a join of loadable AND savable?
      this.loadableVariableNames.reduce(function (acc, name) {
        if (_this9.savableVariableNames.indexOf(name) === -1) return acc;
        acc[name] = _this9.inputs[name];
        return acc;
      }, {}));
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this._cache !== this._serialized;
    }
  }]);
  return SimgateInputStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pathId", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataWasChanged", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataWillLoad", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dataWasLoaded", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataWillSave", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataWasSaved", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "inputWasUpdated", [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      name: "",
      offsets: []
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "stateWasSet", [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return {
      time: 0,
      vars: []
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "inputs", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {
      // ["G:Variable1:G"]: "Variable1Value"
      // etc...
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLoading", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSaved", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isSaved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSaving", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isSaving"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "variableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "variableNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadableVariableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "loadableVariableNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savableVariableNames", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "savableVariableNames"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_cache", [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateCache", [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_serialized", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "_serialized"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDirty", [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "isDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revert", [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "revert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInput", [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "updateInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setState", [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveData", [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "saveData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadData", [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "loadData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearData", [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "clearData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "extendData", [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "extendData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInput", [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, "setInput"), _class.prototype)), _class));
exports.default = SimgateInputStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimgateInputStore, "SimgateInputStore", "src/core_modules/simgate-input-store/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simgate-input-store/index.js
// module chunks = 0